export default __webpack_public_path__ + "static/media/us-pr.f8d9e6c6.svg";